module.exports = "mutation DeleteCartLine($lineId:ID!){deleteCartLine(lineId:$lineId){success}}"